import { Injectable } from "@angular/core";
import { WebApiService } from "../web-api.service";
import { WebApiClient } from "../web-api-client.service";
import { ConsoleInfo } from "../hcr-service.service";

export class UserClient {
    ClinicId:number;
    ClinicCode:string;
    ClinicName:string;
    CompanyCode:string;
    UserName:string;
    State:string;
    StartDatetime:Date;
    LastAlifeDatetime:Date;
    IP:string;
    UserId:number;
    ConnectionId:string;
    ComputerName:string;
    ConsoleConnected:boolean;
    LicenseKey:string;
};
export class Consoles {
    State:string;
    StartDatetime:Date;
    LastAlifeDatetime:Date;
    IP:string;
    ComputerName:string;
};
export class CmdDto {
  To:string;
  From:string;
  Command:string;
  Args:any;
};
export class NotifyDto {
  UserId:number;
  Message:string;
};
@Injectable({providedIn:'root'})
export class ConsoleApi{
    apiService: WebApiService;
    /**
     *
     */
    constructor(private apiClient: WebApiClient) {
        this.apiService = apiClient.createHisService('Console');
    }
    async CurrentClients(companyOnly:boolean): Promise<UserClient[]>{
        var ret = await this.apiService.get('CurrentClients?companyOnly='+companyOnly).toPromise<UserClient[]>();
        return ret;
    }
    async Command(cmd :CmdDto): Promise<{cmdId:string}>{
        return this.apiService.post('Command',cmd).toPromise();
    }
     async Notify(message :NotifyDto): Promise<void>{
        return this.apiService.post('Notify',message).toPromise();
    }
     async NotifyAll(message :string): Promise<void>{
        return this.apiService.post('NotifyAll',{
            UserId:0,
            Message:message
        }).toPromise();
    }
    async GetConsoleInfo(clinicCode:string, computerName:string): Promise<ConsoleInfo>{
        var ret = await this.apiService.get('GetConsoleInfo?clinicCode='+clinicCode+'&computerName='+encodeURIComponent( computerName)).toPromise<ConsoleInfo>();
        return ret;
    }
    async GetConsoleBackUp(clinicCode:string): Promise<{IP:string,Files:ConsoleInfo[]}>{
        var ret = await this.apiService.get('GetConsoleBackUp?clinicCode='+clinicCode).toPromise();
        return ret;
    }
    async GetLogs(clinicId:number, computerName:string): Promise<string[]>{
        var ret = await this.apiService.get('GetLogs?clinicId='+clinicId+'&computerName='+encodeURIComponent( computerName)).toPromise<string[]>();
        return ret;
    }
    
    async ClinicConsoles(): Promise<Consoles[]>{
        var ret = await this.apiService.get('ClinicConsoles').toPromise<Consoles[]>();
        return ret;
    }
}
